// extracted by mini-css-extract-plugin
module.exports = {"appstore":"AgentIcon_appstore__mzS_W"};